import React, { useContext, useEffect, useState } from 'react'
import { pexios, toast } from '../../utils/functions';
import defaultProfile from '../../assets/images/user-icon.png';
import { history, url } from '../../utils/variables';
import Chart from '../../assets/images/chart.PNG';
import Chart2 from '../../assets/images/chart2.PNG';
import Logo from '../../assets/images/hbkf.png';
import SamanNegar from '../../assets/images/saman-negar.png';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../components/master/Modal';
import ExpertInfo from './ExpertInfo';
import { TitleContext } from '../../App';
import { setRouterData } from '../../redux/actions';
import HeaderIcon from '../../assets/images/header-icon/expert-search.png'
function SelectExpert() {
  const {routerData,location} = useSelector(store => store);
  const [loader, setLoader] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const[experts,setExperts] =useState({
    person : [
    // {id :1 , full_name :'مهدیه جمالی'}
    ],
    company: [
      // {id :3 , title :'همراه بیمه خلیج فارس' , img : Logo , diagram : Chart },
      // {id : 2 ,title :'سامان نگار ایرانیان' , img : SamanNegar , diagram : Chart2}
    ]
  })
  const factors = [
    { key :'speed', name :'سرعت عمل'},
    { key :'skill', name :'دقت و مهارت'},
    { key :'behavior', name :'رفتار سازمانی'},
    { key :'experience', name :'تجربه جمعی'}
  ]
  const [select ,setSelect] =useState({id: 0});
  const [expertType,setExpertType] = useState(null)
  // const [step,setStep] = useState(0)
  const dispatch = useDispatch()
  // const { setTitle } = useContext(TitleContext);
  // useEffect(()=>{
  //   setTitle('انتخاب کارشناس')
  // },[])

  useEffect(()=>{
    // let data
    setLoader(true)
    if(routerData?.state === 3) {
      history.push('/accident-report')
      return;
    }
    // pexios('/api/get_address','post',location)
    //     .then((res)=>{
    //         const response = res.data
          const data =  {
              accident_id : routerData.id,
              ...location
              // state_id : location.state_id,
              // city_id: location.city_id,
              // lat : location.lat,
              // lng : location.lng
            }
        // })
        // .then(()=>{
          pexios('/api/suggesting_expert','post',data)
          .then((res)=>{
            setExperts({
              person : res.data.expert,
              company : res.data.company
            });
            setLoader(false)
          })
        // })
  },[location])
  function submit() {
    setBtnLoading(true)
    const data = {
      accident_id : routerData.id,
      expert:{...select},
      type :expertType
    }
    pexios('/api/select_expert','post',{...data})
    .then(()=>{
      // setStep(1)
      // toast('پرونده شما تکمیل شد در اسرع وقت با شما تماس گرفته خواهد شد .');
      // dispatch(setRouterData({...routerData,expertInfo:{expert: select,type : expertType}}))
      dispatch(setRouterData({ ...routerData,state: 3}));
      setTimeout(()=>history.push('/accident-report'));
    })
    .catch(()=>{
      setBtnLoading(false)
      toast('خطا در انتخاب کارشناس','error')
    })
  }
  function expertChange(expert,type) {
    setSelect(expert)
    setExpertType(type)
  }
  return (
    <>
          <div className='content select-expert'>
          {loader &&
              <Modal visible={loader}>
                  <div className='loader-modal'>
                      <i className='fas fa-spinner fa-spin'/>
                  </div>
              </Modal>
          }
          <div className='title-image'>
              <img src={HeaderIcon} alt="icon"/>
          </div>
          {(!loader && experts.person.length === 0 && experts.company.length === 0) ?
          <>
            <p className='notFound-text b-bl-sharp'>کارشناسی در محل مورد نظر شما فعالیت نمیکند</p>
            <div className='d-flex group-btns mt50'>
              <button className={`btn btn-circle btn-block btn-orange`} onClick={()=>history.push('/')}>انصراف  </button>
              <button className='btn btn-circle btn-block btn-white-purple btn-bold'onClick={()=>history.push('/get_location')}>تغییر مکان بازدید کارشناس  </button>
            </div>
          </>
          :
          <>
          <p className='guide-text mx10 mt10'>
            در لیست زیر کارشناسان حقوقی و حقیقی براساس موقعیت مکانی اعلام شده شما پیشنهاد داده شده اند.
            شما میتوانید یکی از کارشناسان پیشنهادی را برای پرونده خود انتخاب نمایید.         
          </p>
          {experts.company.length > 0 &&
            <>
              <div className='title m10 rtl'><div className='pl10'>کارشناسان حقوقی</div><span className='line'/></div>
                {experts.company.map((cmp)=>(
                  <div key={cmp.id} className={`expert-box ${select.id === cmp.id && 'selected'}`} onClick={()=>expertChange(cmp,'company')}>
                  <div className='info'>   
                  <span className='radio-btn' />
                  <div className='d-flex flex-column mr30'>   
                        <h5>{cmp.title}</h5>
                        <p>ارزیاب حقوقی</p>
                      </div>
                    <img      
                        className='profile mr10'          
                        src={
                            cmp.avatar ?
                                `${url}/files?uid=${cmp.avatar.uid}` :
                                defaultProfile
                        }
                        alt='profile'
                    />
                  </div>
                  {/* <div className='diagram'>
                    <img src={Chart2}/>
                  </div> */}
            </div>
                ))}
              </>
              } 
          {experts.person.length > 0 &&
            <>
              <div className='title m10 rtl'><div className='pl10'>کارشناسان حقیقی</div><span className='line'/></div>
              {experts.person.map((expert)=>(
                <div className={`expert-box ${select.id === expert.id && 'selected'}`} onClick={()=>expertChange(expert,'user')} key={expert.id}>
                  <div className='mb10 info'> 
                  <span className='radio-btn' />  
                  <div className='d-flex flex-column mr30'>   
                        <h5>{expert.full_name}</h5>
                        <p>فاصله تقریبی : {expert.distance} کیلومتر</p>
                      </div>
                      <img      
                        className='profile mr10'          
                        src={
                            expert.avatar ?
                                `${url}/files?uid=${expert.avatar.uid}` :
                                defaultProfile
                        }
                        alt='profile'
                    />
                  </div>
                  <div className='d-flex flex-wrap' style={{width: '100%'}}>
                  {factors.map((factor)=>(
                    <div className='diagram' key={factor.key}>
                    {/* <p className='percent'>{expert.data.score[factor.key]}%</p> */}
                    <div className='progress'>
                    <div className='bar' style={{width: `${expert.data.score[factor.key]}%`}}></div>
                    <div className='line'></div>
                    </div>
                    <p className='item'>{factor.name}</p>
                    </div>
                  ))}
                  </div>
            </div>
              ))}
            </>}
              {(experts.person.length > 0 || experts.company.length > 0 )&&
                <div className='d-flex justify-center ml10 mr10'>
                    <button className={`btn btn-circle w-50 m10 ${select.id !== 0 ? 'btn-white-purple' : 'btn-disable'}`} disabled={select.id === 0 || btnLoading} onClick={submit}>
                      {btnLoading ? <i className='fas fa-spinner fa-spin' />:' ثبت نهایی '}
                    </button>
                    <button className={`btn btn-circle w-50 m10 btn-orange`} onClick={()=>history.push('/get_location')}>تغییر مکان حادثه  </button>
                </div>
              }  
            </>
            }       
        </div>
      {/* {step === 1 && <ExpertInfo expert={select} type={expertType}/>} */}
    </>
  )
}

export default SelectExpert;